<mat-form-field (click)="$event.stopPropagation()" subscriptSizing="dynamic" appearance="outline">
    <mat-icon matPrefix svgIcon="magnify"></mat-icon>
    <input matInput #selectInput (keydown)="$event.stopPropagation()" [formControl]="termInput"
        autocomplete="off" />
    <button *ngIf="strictSearch !== undefined" mat-icon-button matSuffix class="field-icon syn--format-button"
        (click)="switchStrictMode()"
        matTooltip="{{ translations?.TOOLTIPS?.STRICT_FILTER_BUTTON || 'Recherche du mot complet' }}"
        matTooltipPosition="left">
        <mat-icon class="syn--underline-icon" color="{{strictSearch ? 'accent' : 'primary'}}" svgIcon="format-underline"></mat-icon>
    </button>

    <button mat-icon-button matSuffix class="field-icon" (click)="clearInput()" *ngIf="termInput.value" [style.padding]="'0px'" [style.width]="'24px'" [style.height]="'24px'">
        <mat-icon class='syn--close' [style.padding]="'0px 0px 6px 0px'" svgIcon="close">close</mat-icon>
    </button>
</mat-form-field>
